/**
 * Use this for functions which can be used in the view to better describe
 * interactions with observables.
 */
define('common/ko/fn/viewDSL',['knockout'], function(ko) {

    /**
     * Returns a function which will update the observable to value when called.
     */
    ko.subscribable.fn.becomes = function(value) {
        return function() {
            this(value);
        }.bind(this);
    };

    /**
     * Returns a function which will toggle the boolean value of an observable.
     */
    ko.subscribable.fn.toggles = function() {
        return function() {

            if (arguments[1] && arguments[1].stopPropagation) {
                arguments[1].stopPropagation();
            }

            this(!this());

        }.bind(this);
    };

});

